import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';

export const TextHeader = (props) => {
    const [text, setText] = useState("");
    const [blocksLength, setBlocksLength] = useState("");

    useEffect(() => {
        setText(props.text);
        setBlocksLength(props.blocksLength);
    });

    return (
        <div className="text-header-box">
            <Row className="text-header">
                <Col lg="" className="text-header-text">
                    {text}
                </Col>
            </Row>
            <Row>
                <Col lg={blocksLength} className="text-header-underscore">
                </Col>
            </Row>
        </div>
    );
}

export const TextTitle = (props) => {
    const [text, setText] = useState("");
    const [addClass, setAddClass] = useState("");

    useEffect(() => {
        setText(props.text);
        setAddClass(props.addClass);
    });

    return (
        <Row className="text-title">
            <Col lg="12" className="text-title-text" >
                {text}
            </Col>
        </Row>
    );
}

export const TextBock = (props) => {
    const [text, setText] = useState("");
    const [addClass, setAddClass] = useState("");

    useEffect(() => {
        setText(props.text);
        setAddClass(props.addClass);
    });

    return (
        <Row className="text-block">
            <Col lg="12" className="text-block-text">
                <p className={addClass}>
                    {text}
                </p>
            </Col>
        </Row>
    );
}